import { render, staticRenderFns } from "./CmgPasswordReset.vue?vue&type=template&id=2820fdb4&scoped=true&lang=pug&"
import script from "./cmg-password-reset.ts?vue&type=script&lang=ts&"
export * from "./cmg-password-reset.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2820fdb4",
  null
  
)

export default component.exports